<template>
	<v-dialog v-model="dialogContato" max-width="330">
		<div class="cardContato">
			<div class="cardContatoTitulo">Contatos</div>
			<template v-for="(contato, i) in contatos">
				<div class="cardContatoConteudo" :key="i">
					<div class="cardContatoTextuais">
						<div class="cardContatoCidade">{{ contato.cidade }}</div>
						<div class="cardContatoNumero">{{ contato.telefone }}</div>
					</div>
					<div>
						<v-btn class="mr-2" color="primary" @click="ligar(contato.whatsapp)">
							<strong>Ligar</strong>
						</v-btn>
						<v-btn color="#25D366" class="white--text" @click="chamarWhatsapp(contato.whatsapp)">
                            <v-icon>
                                mdi-whatsapp
                            </v-icon>
							<strong>WhatsApp</strong>
						</v-btn>
					</div>
				</div>
			</template>
		</div>
	</v-dialog>
</template>

<script>
import montaMensagemContato from '../../mixins/methods/montaMensagemContato'

export default {
	props: {
		dialog: Boolean,
	},
	data() {
		return {
			contatos: [
				{
					cidade: 'Jataí - GO',
					telefone: '(64) 3631-4248',
                    whatsapp: '6436314248',
				},
				{
					cidade: 'Rio Verde - GO',
					telefone: '(64) 3602-7400',
                    whatsapp: '6436027400',
				},
			],
		}
	},
	computed: {
		dialogContato: {
			get() {
				return this.dialog
			},
			set() {
				this.dialogClose()
			},
		},
	},
	methods: {
		click() {
			this.dialogClose()
		},
		dialogClose() {
			this.$emit('dialogClose')
		},
        chamarWhatsapp(telefone) {
			const url = montaMensagemContato(telefone, 'Olá!')
			window.location.replace(url)
		},
		ligar(telefone) {
			if (telefone) window.location.href = `tel:${telefone}`
		},
	},
}
</script>

<style>
.cardContato {
	background-color: white;
	background-color: #ffffff;
	border-radius: 8px 8px 8px 8px;
	padding: 10px;
	width: 100%;
}
.cardContatoTitulo {
	font-size: 30px;
	font-weight: 900;
	color: #cc2128;
}
.cardContatoCidade {
	font-weight: 600;
}
.cardContatoNumero {
    font-size: 14px;
}
.cardContatoTextuais {
	margin-right: 13px;
}
.cardContatoConteudo {
	display: flex;
	align-items: center;
	margin-bottom: 15px;
}
</style>